import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
//import SideBar from './sidebar.js';
import StoryItem from './storyitems.js';
import { useQuery } from '@apollo/client';
//import { onError } from '@apollo/client/link/error';
import { LOAD_STORY } from '../graphql/queries.js';
import RelatedStories from './relatedstories.js';
//import GoogleAds from './googleads.js';
import MyLoader from './myjoyloader.js';
//import { mdiCommentMinusOutline } from '@mdi/js';
//import { useCookies } from 'react-cookie';
import Customad from './customad.js';
import Mobilead from './mobilead.js';
import Subcategory from './subcategorylist.js';
import Recommended from './related.js';



function Single( {match} ){

  const location = useLocation();
  //const [cookies, setCookie] = useCookies(['user']);
  const slug = match.params.id;
  const [newsitem, setNewsitem] = useState([]);
  const [storyimage, setStoryimage] = useState(location.state?.storyimage)
  const [tags,setTags] = useState();
  //const [title,setTitle] = useState()
  //const [storycontent,setStorycontent] = useState("")
  const [id,setId] = useState(location.state?.itemid);
  const [storyauthor,setStoryauthor] = useState();
  const [rtag,setRtag] = useState()
  const [category,setCategory] = useState();   
  const [guid,setGuid] = useState();
  const [parentcat,setParentcat] = useState();
  const [parentname,setParentname] = useState();
  const [catchildren,setCatchildren] = useState([])
  const {error, loading, data} = useQuery(LOAD_STORY, {variables: {slug: slug}});
  
   
 


      useEffect(()=> {
        if(data){
           
            setNewsitem(data.postBy)
            setStoryimage(data.postBy.featuredImage.node.sourceUrl)
            setCategory(data.postBy.categories.nodes[0].name)
            setStoryauthor(data.postBy.author.node.name)

            if(data.postBy.categories.nodes[0].parent == null){

              setParentcat(data.postBy.categories.nodes[0].categoryId)
              setParentname(data.postBy.categories.nodes[0].name)
              if(data.postBy.categories.nodes[0].children.nodes.length > 0){
                setCatchildren(data.postBy.categories.nodes[0].children.nodes)
              }
              
              
            }else{

              setParentcat(data.postBy.categories.nodes[0].parent.node.categoryId)
              setParentname(data.postBy.categories.nodes[0].parent.node.name)
              setCatchildren(data.postBy.categories.nodes[0].parent.node.children.nodes)
            }
            
            
            //setStoryauthor(data.postBy.author.node.name)
            let n = data.postBy.tags.nodes.length
            let tgs = ""
            let storyC = data.postBy.content
            let articleid = data.postBy.guid.split("p=")
            setGuid(articleid[1])

            for(let i=0;i<n;i++){
                if(i < data.postBy.tags.nodes.length-1){

                    tgs += data.postBy.tags.nodes[i].name.replace(/""/gi,"-") +",";
                }else{
                    tgs += data.postBy.tags.nodes[i].name.replace(/""/gi,"-")
                }
                 
            }
            setRtag(tgs)
            setTags(data.postBy.tags.nodes);
        }  


      },[data])
  
      
      if(error){ 
          
        return <div>Error Loading Content</div>
    
    }


    if(loading){

        return <div style={{textAlign:"center"}}><MyLoader /></div>
    }
  // this.history.push("/foo")
    
    return(
     <div>
       
         
         {
        
         loading && tags =="" ? <div style={{marginTop: "10px"}}><MyLoader /></div> :
        <> 
        <Mobilead id={"myjoyonline_article_top"} slot="/1002554/Myjoyonline/myjoyonline_article_top" />
  <StoryItem guid={guid} catchildren={catchildren} parentname={parentname} storyauthor={storyauthor} storyexcerpt={newsitem.excerpt} category={category} itemref={newsitem.id} id={newsitem.id} title={newsitem.title} content={newsitem.content} storyimage={storyimage} tags={tags} vuukletags={rtag} datepublished={newsitem.dateGmt} storyurl={slug} storyid={id} slug={slug} source={newsitem.source} />
            
                <Customad id={guid} slot="/1002554/Myjoyonline/myjoyonline_home_feed_native" />
            
              <RelatedStories tags={rtag}  slugid={slug} storyid={guid} /> 
              
           
         </>

        }
         

     </div>
    )  
}

export default Single;